var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 9.5C10.8722 9.5 11.25 9.12224 11.25 8.65625C11.25 8.19026 10.8722 7.8125 10.4062 7.8125C9.94026 7.8125 9.5625 8.19026 9.5625 8.65625C9.5625 9.12224 9.94026 9.5 10.4062 9.5Z",
    fill: "#1B2436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 9.5C13.6847 9.5 14.0625 9.12224 14.0625 8.65625C14.0625 8.19026 13.6847 7.8125 13.2188 7.8125C12.7528 7.8125 12.375 8.19026 12.375 8.65625C12.375 9.12224 12.7528 9.5 13.2188 9.5Z",
    fill: "#1B2436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 12.3125C10.8722 12.3125 11.25 11.9347 11.25 11.4688C11.25 11.0028 10.8722 10.625 10.4062 10.625C9.94026 10.625 9.5625 11.0028 9.5625 11.4688C9.5625 11.9347 9.94026 12.3125 10.4062 12.3125Z",
    fill: "#1B2436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 12.3125C13.6847 12.3125 14.0625 11.9347 14.0625 11.4688C14.0625 11.0028 13.6847 10.625 13.2188 10.625C12.7528 10.625 12.375 11.0028 12.375 11.4688C12.375 11.9347 12.7528 12.3125 13.2188 12.3125Z",
    fill: "#1B2436"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 12.3125C5.24724 12.3125 5.625 11.9347 5.625 11.4688C5.625 11.0028 5.24724 10.625 4.78125 10.625C4.31526 10.625 3.9375 11.0028 3.9375 11.4688C3.9375 11.9347 4.31526 12.3125 4.78125 12.3125Z",
    fill: "#1B2436"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 12.3125C8.05974 12.3125 8.4375 11.9347 8.4375 11.4688C8.4375 11.0028 8.05974 10.625 7.59375 10.625C7.12776 10.625 6.75 11.0028 6.75 11.4688C6.75 11.9347 7.12776 12.3125 7.59375 12.3125Z",
    fill: "#1B2436"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 15.125C5.24724 15.125 5.625 14.7472 5.625 14.2812C5.625 13.8153 5.24724 13.4375 4.78125 13.4375C4.31526 13.4375 3.9375 13.8153 3.9375 14.2812C3.9375 14.7472 4.31526 15.125 4.78125 15.125Z",
    fill: "#1B2436"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 15.125C8.05974 15.125 8.4375 14.7472 8.4375 14.2812C8.4375 13.8153 8.05974 13.4375 7.59375 13.4375C7.12776 13.4375 6.75 13.8153 6.75 14.2812C6.75 14.7472 7.12776 15.125 7.59375 15.125Z",
    fill: "#1B2436"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 15.125C10.8722 15.125 11.25 14.7472 11.25 14.2812C11.25 13.8153 10.8722 13.4375 10.4062 13.4375C9.94026 13.4375 9.5625 13.8153 9.5625 14.2812C9.5625 14.7472 9.94026 15.125 10.4062 15.125Z",
    fill: "#1B2436"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0625 2.1875C5.0625 1.87684 4.81066 1.625 4.5 1.625C4.18934 1.625 3.9375 1.87684 3.9375 2.1875V2.75H3.375C2.13236 2.75 1.125 3.75736 1.125 5V15.125C1.125 16.3676 2.13236 17.375 3.375 17.375H14.625C15.8676 17.375 16.875 16.3676 16.875 15.125V5C16.875 3.75736 15.8676 2.75 14.625 2.75H14.0625V2.1875C14.0625 1.87684 13.8107 1.625 13.5 1.625C13.1893 1.625 12.9375 1.87684 12.9375 2.1875V2.75H5.0625V2.1875ZM14.625 3.875C15.2463 3.875 15.75 4.37868 15.75 5V5.5625H2.25V5C2.25 4.37868 2.75368 3.875 3.375 3.875H14.625ZM2.25 6.6875V15.125C2.25 15.7463 2.75368 16.25 3.375 16.25H14.625C15.2463 16.25 15.75 15.7463 15.75 15.125V6.6875H2.25Z",
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.388cd8b6f474c0b32a76751ffacba3a4.svg";
export { ForwardRef as ReactComponent };